import React from "react";
import BrandSettingForm from "./BrandSettingForm";

const AddBrandSetting = ({ onFinalSubmit }) => {
  return <BrandSettingForm isEdit={false} onFinalSubmit={onFinalSubmit} />;
};

export default AddBrandSetting;